<template></template>

<script>
import Vue from 'vue'
import Zendesk from '@dansmaculotte/vue-zendesk'
import ZENDESK from '@/config/zendesk.js'
import { primary, darkPrimary } from '@/plugins/vuetify'
import { DARKMODE_LOCAL_STORAGE_KEY } from '@/constants'

Vue.use(Zendesk, {
  key: ZENDESK.apiKey,
  errorReporting: true,
  hideOnLoad: true,
  settings: {
    webWidget: {
      color: {
        theme: localStorage.getItem(DARKMODE_LOCAL_STORAGE_KEY) === 'true' ? darkPrimary : primary
      },
      contactForm: {
        attachments: false
      }
    }
  }
})

export default {
  name: 'ZendeskWidget',
  props: {
    locale: String
  },
  methods: {
    setLocale (lang) { this.$zendesk.setLocale(lang) }
  },
  watch: {
    locale (lang) { this.setLocale(lang) }
  },
  mounted () {
    this.setLocale(this.locale)
  }
}

</script>
